// extracted by mini-css-extract-plugin
export default {"desc":"FinalizeSoaModal_desc__5VIIC","label":"FinalizeSoaModal_label__Tmkbg","required":"FinalizeSoaModal_required__C8O6C"};